/* NAIVROX recently-viewed — per-visitor, localStorage only */
(function () {
  var KEY = 'nvx_recently_viewed_v1';
  var MAX_STORE = 20;

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORE)));
    } catch (e) {}
  }

  function money(cents) {
    if (cents == null) return '';
    var fmt = window.nvxMoney || 'Rs {{amount}}';
    var amount = (cents / 100).toLocaleString(undefined, { maximumFractionDigits: 0 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/g, amount).replace(/<[^>]+>/g, '').trim();
  }

  // 1. Record current product
  var cur = document.querySelector('[data-nvx-rv-current]');
  if (cur) {
    try {
      var p = JSON.parse(cur.textContent);
      if (p && p.handle) {
        var list = read().filter(function (x) {
          return x.handle !== p.handle;
        });
        list.unshift(p);
        write(list);
      }
    } catch (e) {}
  }

  // 2. Render rail
  var root = document.querySelector('.nvx-rv');
  if (!root) return;
  var grid = root.querySelector('.nvx-rv__grid');
  var max = parseInt(root.dataset.max, 10) || 8;
  var curHandle = cur ? (JSON.parse(cur.textContent) || {}).handle : null;

  var items = read()
    .filter(function (x) {
      return x.handle && x.handle !== curHandle;
    })
    .slice(0, max);

  if (items.length < 2) return;

  grid.innerHTML = items
    .map(function (x) {
      var onSale = x.compare_at && x.compare_at > x.price;
      return (
        '<li class="nvx-rv__card">' +
        '<a href="' + x.url + '">' +
        (x.image ? '<img src="' + x.image + '" alt="" loading="lazy" width="300" height="300">' : '') +
        '<span class="nvx-rv__title">' + (x.title || '') + '</span>' +
        '<span class="nvx-rv__price">' + money(x.price) +
        (onSale ? ' <s>' + money(x.compare_at) + '</s>' : '') +
        '</span>' +
        '</a></li>'
      );
    })
    .join('');

  root.hidden = false;
})();
